import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {OrderItem, OrderQuery} from "src/app/model/order/order";
import {PaginatedSearchRequest, PaginatedSearchResponse} from "src/app/model/pagination/pagination";
import {OrdersApiService} from "../../api/orders-api.service";
import {AuthHttpService} from "../../api/auth-http.service";
import {MessageService} from "../../utils/message/message.service";
import * as FileSaver from "file-saver";

@Injectable()
export class HomeOrdersService {

  constructor(
    private httpService: AuthHttpService,
    private ordersApi: OrdersApiService,
    private messages: MessageService,
  ) {
  }

  getHomeOrders(search: PaginatedSearchRequest<OrderQuery>): Observable<PaginatedSearchResponse<OrderItem>> {
    return this.ordersApi.searchOrders(search);
  }

  delete(item: OrderItem) {
    this.ordersApi.deleteOrderItem(item).subscribe(() => {
      this.messages.info("home.orders.orderItemDeleted");
    })
  }

  downloadReport(items: OrderItem[]) {
    this.ordersApi.downloadReport(items).subscribe(blob => {
      FileSaver.saveAs(blob, "Orders.pdf");
    });
  }
}
